<template>
  <div class="container">
    <router-view />
    <Privacy ref="vPrivacy"></Privacy>
    <GoTop ref="vGoTop"></GoTop>
  </div>
</template>

<script>
export default {
  name: "layout"
};
</script>
<style></style>
